import type { FC, ReactNode } from "react";

import { BlockedActionTooltip } from "../blocked-action-tooltip";
import { Button } from "../button";
import { ButtonGroup } from "../button-group";
import { CardFooter } from "../card";
import { Icon } from "../icon";
import { Spinner } from "../loading";
import { useEmailDraft } from "./email-draft-context";

export const EmailDraftFooter: FC<{ extras?: ReactNode }> = ({ extras }) => {
  const { isSending, isEditable, handleSend, sendBlockedReason } = useEmailDraft();

  return (
    <CardFooter className="flex-0 p-6 py-4 justify-end">
      <ButtonGroup className="flex-grow-1 flex-nowrap">
        <BlockedActionTooltip reason={sendBlockedReason}>
          <Button
            variant="default"
            theme="primary"
            size="sm"
            onClick={handleSend}
            disabled={isSending || !isEditable || !!sendBlockedReason}
          >
            {isSending ? (
              <>
                <Spinner className="size-3" />
                Sending&hellip;
              </>
            ) : (
              <>
                <Icon icon="send" />
                Send
              </>
            )}
          </Button>
        </BlockedActionTooltip>
        {extras}
      </ButtonGroup>
    </CardFooter>
  );
};
